
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as errornGnnVf3YiwP60W_BCRsPvOMTJi0EztZBhT8ARDNnqAYMeta } from "/app/pages/auth/error.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as indext_45gR0RZcFnfLegqBLIdEbcl6ND0KdXwG7n3TGxg1HUsMeta } from "/app/pages/exam/index.vue?macro=true";
import { default as indexQ_45p_R8nWqy4cZICdOG47zZGdB894pqt8jkBF_45IT0qhIMeta } from "/app/pages/home/index.vue?macro=true";
import { default as indexgkmYvc0BL4hfkjxgFAdtjSc_hHp1Ay7EhpNxKOk43esMeta } from "/app/pages/role/index.vue?macro=true";
import { default as indexVjBxRMPTh0d_45TIglqBCJuLMPrZuvab79N9Um0vxN3ggMeta } from "/app/pages/user/index.vue?macro=true";
import { default as indexv_wPUXh72NA3FuqMMZNfgSSLCVJFmK8zPdnYi9Rx2MUMeta } from "/app/pages/block/index.vue?macro=true";
import { default as indexQ2XknYyc5pBDpRzn9udkDp9sYEpRAWu7uB5__WEvmxIMeta } from "/app/pages/files/index.vue?macro=true";
import { default as indexfn7PzI_5kslBwThPL0JSaXpekuFiZ1AZmG_zw_45YR_45NQMeta } from "/app/pages/nurse/index.vue?macro=true";
import { default as indexolbdBLy3g7xtsrzI2mgg0ddKLEKAVrXPnt4rQtd_KkoMeta } from "/app/pages/place/index.vue?macro=true";
import { default as indexizqqoe2jmesH3R0di7nNltbPGE7ZQC0_454GewCbx5HtEMeta } from "/app/pages/rooms/index.vue?macro=true";
import { default as indexDmnjOF2iUFFC3JT1wywmGZHSVIQv1x72yRKSduQi25gMeta } from "/app/pages/taxes/index.vue?macro=true";
import { default as createeW5MODV8phwOEB2t6_45knlEFtFks53xoIkKNJzxnLTgoMeta } from "/app/pages/user/create.vue?macro=true";
import { default as index1j2r86Qf_Sh80__gp_EK_qhrwt3xzb_45Rb_SyPEBixv2cMeta } from "/app/pages/user/index1.vue?macro=true";
import { default as createo1p4ci_45B3ltxA_45dxUteejuEHjDHI2lEIL7EJLOaUvJYMeta } from "/app/pages/block/create.vue?macro=true";
import { default as create81jOomMskIC412Tm30gCTCuv_45S_45JdWXCqt_45RiRyte5UMeta } from "/app/pages/place/create.vue?macro=true";
import { default as indexM5K0l1sk3UKPNUQMqdQ0KewLr3G64wy_xltyH4w_45qCYMeta } from "/app/pages/report/index.vue?macro=true";
import { default as create1dkJWphstfMbNRcdW5kepZf7C4sSW9vYgjB6zZHdp_45KcMeta } from "/app/pages/user/create1.vue?macro=true";
import { default as profileRzaLXe48fgBOIVJMfkhkJBaYQGtPw_7WQJHNGvhmFcYMeta } from "/app/pages/user/profile.vue?macro=true";
import { default as registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta } from "/app/pages/auth/register.vue?macro=true";
import { default as indexEgzhaAvXJrRs5sUxaO2vJLnBwSFIHFB23ees6bkD2agMeta } from "/app/pages/invoice/index.vue?macro=true";
import { default as indexlYcu4N9sv4FGZHQeTpP6SjPSlylyOGF2nS3PYfXaWVkMeta } from "/app/pages/modules/index.vue?macro=true";
import { default as indexJShk27dRSWfsze5T07DMDSKRnqsALdb8h6oYoL56uS0Meta } from "/app/pages/patient/index.vue?macro=true";
import { default as index06BSkQOU17mN_EHXmxqHlfcDCKM0WEWrlAdjzc4wDkEMeta } from "/app/pages/payment/index.vue?macro=true";
import { default as indexFEjRYI_Sid24Fwd_45HM6Cgh_45cnTQbFAOD43twbosPgagMeta } from "/app/pages/service/index.vue?macro=true";
import { default as indexYy6z47VVk5azhp4SjBjqI9NRCfN8UBfw55Ybh3if0ywMeta } from "/app/pages/vaccine/index.vue?macro=true";
import { default as indexCWfsSKoZQpL6KiGJOkf2jLCcPJ_45ORoIGKQZ3NBuShAoMeta } from "/app/pages/business/index.vue?macro=true";
import { default as index78qn3ibMiUImmHYj7xJcqLR_45Org9ITNbEaDYkCGEqy8Meta } from "/app/pages/calendar/index.vue?macro=true";
import { default as index0eicFF7xXICy0spCQRecFZJGGFRQbc0_Ljzu_mhq19EMeta } from "/app/pages/category/index.vue?macro=true";
import { default as index6fm8CgdwOju8TBx8nstTja17zRCmF1aU4YlXJ7Fam84Meta } from "/app/pages/medicine/index.vue?macro=true";
import { default as createJOUvq4dfbAnYZxI1aputjMSk60BifYI8S7c3Vls5QPYMeta } from "/app/pages/modules/create.vue?macro=true";
import { default as createWnKYN5XRudgUD8jynERZ1shDSqLXnrxpl_4E32iczCIMeta } from "/app/pages/patient/create.vue?macro=true";
import { default as index16krXv_45JmbVCe_Gvls_45i_Nt1VFb5JmMg2pLj6KTsH7zkMeta } from "/app/pages/patient/index1.vue?macro=true";
import { default as createqioVT04qKxkrXygNer2TlF7bCu1iLTbIak6LXthzslwMeta } from "/app/pages/payment/create.vue?macro=true";
import { default as indexCS9TBWZLvVvHfBzyOBaud5vfuMt23eSrxLSN_ubukeEMeta } from "/app/pages/products/index.vue?macro=true";
import { default as indexoWchnuOv7HJwfiWBxKy_2ExNBB64ADFcgNfIkXhtlwoMeta } from "/app/pages/resource/index.vue?macro=true";
import { default as _91id_93C5m7O9fQvBgsUNlMboHv6kY6OM4psDYWKNG3ciNg8hYMeta } from "/app/pages/user/edit/[id].vue?macro=true";
import { default as createRPwpswuSZJgfZJmW1P0f_45UC9vppKPt6or9NJLwH3CawMeta } from "/app/pages/vaccine/create.vue?macro=true";
import { default as indexjYE1BVSc6iX6gF8ZMf9VvmHWgWZ_45RQ3j5taBh7NkKgcMeta } from "/app/pages/assistant/index.vue?macro=true";
import { default as lockScreenwHnOoC9OPAE0mUIumKItiYETIjpCVA0jJpTssyA3V2sMeta } from "/app/pages/auth/lockScreen.vue?macro=true";
import { default as _91id_93Gs9thfI_45UZTPLU4SZ71ATGwzlYebeGq14KngMrrFjWEMeta } from "/app/pages/block/edit/[id].vue?macro=true";
import { default as create5q8dlOA_X0mIfuvDBbPZdctn3FQYbMpq9R04nwks0SQMeta } from "/app/pages/business/create.vue?macro=true";
import { default as indexQwDjgSDxHDI0TxKEAOFFXrW5MT6K_45fV_9kXC5ptwtq0Meta } from "/app/pages/customers/index.vue?macro=true";
import { default as index9jbC5nkuFpDxOM_y_4NSWLZKe2o35ZSs8P8Shjyho3cMeta } from "/app/pages/insurance/index.vue?macro=true";
import { default as _91id_93NdO24B4oO4Py3YtP13_BKiZD5fpuT34r6NPoSIZBHusMeta } from "/app/pages/place/edit/[id].vue?macro=true";
import { default as indexB7nc_45bBExN2PmtIFZ08qmgybki5gRW8Tw_45D0gdZI9jMMeta } from "/app/pages/procedure/index.vue?macro=true";
import { default as createDGCqJTe48QFwStKCkseNijf8lplfhpduAYbaDigvgh4Meta } from "/app/pages/resource/create.vue?macro=true";
import { default as index8V5Wo2ipHTDtMmqWa7Drv6E8JtKabbimgnKXlZHLAk8Meta } from "/app/pages/signature/index.vue?macro=true";
import { default as indexwZMnm4SdJK0OFomUCKmEa5fdZKV0FQ4qRlWgJmsoJtsMeta } from "/app/pages/surgeries/index.vue?macro=true";
import { default as create493tRY7ObRtyqr6bkz_459X4ghOLmm5qCbDDcMVssDRAEMeta } from "/app/pages/assistant/create.vue?macro=true";
import { default as index1YULZxAhwP8NtSR4lnscOhOKnDY15Q49vDRRJ_45QwwLW0Meta } from "/app/pages/assistant/index1.vue?macro=true";
import { default as newPasswordSCSUfa4lH2XeJXN1a2W7vQO990GsvTqksaE2f2ZnKZQMeta } from "/app/pages/auth/newPassword.vue?macro=true";
import { default as createSgYbFe_csKwx_52sRYnHBWhZXcS4zaok_45EgHQQ0NCggMeta } from "/app/pages/customers/create.vue?macro=true";
import { default as createTd_sPEsvxS_urMK4_45FO_Ql89qn5pkdB18Mi3oSd7nOAMeta } from "/app/pages/insurance/create.vue?macro=true";
import { default as createS7mnL6ZS1sAUZWzSwtw6vOZpBC2apnStiQnTe0qZVRYMeta } from "/app/pages/procedure/create.vue?macro=true";
import { default as createIpEec62k1p8J8EsiIufAM9tY2YUc1qiNSIFftrn2Z6AMeta } from "/app/pages/surgeries/create.vue?macro=true";
import { default as indexnJw8U7fTduLDdP_ZsjyMzyqhCyITE_MjjJVQ6AjeNfYMeta } from "/app/pages/advertising/index.vue?macro=true";
import { default as indexpeff7cQB0er9Ql9GJGBf_Kvhf8L3mPThB2he3KXjccMMeta } from "/app/pages/appointment/index.vue?macro=true";
import { default as accessDeniedyzjBPzCggfpfGkEi9AuxA94KFUZj80vEAf9kdsPTg94Meta } from "/app/pages/auth/accessDenied.vue?macro=true";
import { default as verificationbM4oBvUs_LE4PQnVgFXTHI2uwksUQUAY8fXuw96HK_EMeta } from "/app/pages/auth/verification.vue?macro=true";
import { default as _91id_93TfCl6k4DqT5V2h_tVH0xGBSsYUXHZaqMsgd2y4Qy20cMeta } from "/app/pages/modules/edit/[id].vue?macro=true";
import { default as index3XUwMFHHJ76gj5U897TpWMZiXkjE1ZuGDk63k8lgBWQMeta } from "/app/pages/new-patient/index.vue?macro=true";
import { default as _91id_93yPWhvNGuK9_4_MeG0YGh9EQxi5UIOIaov4Sr4llCcZMMeta } from "/app/pages/patient/edit/[id].vue?macro=true";
import { default as indext6RJr_45gIt8XR5r5pEpeQUyAPKNOA4LvS79ckdufflkMMeta } from "/app/pages/payment-btn/index.vue?macro=true";
import { default as _91id_93pMjMyBPPGsmCNbm5wJ4TYKg_45G0oA9cT3zIe1gBcGIpUMeta } from "/app/pages/payment/edit/[id].vue?macro=true";
import { default as indexmFHuXm1TRDyTx4rDob8_G9bfnp43YCs_HCFMFiG56X4Meta } from "/app/pages/permissions/index.vue?macro=true";
import { default as _91id_93qI4PbXrSDdkEUzCMBxCpKNfjuvVY_45ax_455S_g31LxUaMMeta } from "/app/pages/service/edit/[id].vue?macro=true";
import { default as _91id_93ov0B1UI3vLTHYqlPm_MulTcgNXMdBnJwd6yWM_45sPxSAMeta } from "/app/pages/vaccine/edit/[id].vue?macro=true";
import { default as createpNKg2lI7Q7Lj89KX_453HW6gCuN376i_45pOf6MUM9gSi6MMeta } from "/app/pages/appointment/create.vue?macro=true";
import { default as _91id_93yOo4bmKihQWW2bmLu_45pjeq4PGrlP5Z9ISpuTN7CctYUMeta } from "/app/pages/business/edit/[id].vue?macro=true";
import { default as indexxkTCKlXaqdLW_jGlgqc2nmUL0xnhW2PMSGOd2hz27E4Meta } from "/app/pages/consultation/index.vue?macro=true";
import { default as create8ZgaF7FTdUQxUNg9s9CnycFzV__76Rjz3AvfBoMV3rsMeta } from "/app/pages/permissions/create.vue?macro=true";
import { default as _91id_93Qcl22ScXtABw8eBI4Aja2X7c7wQH9V_45DErMOMa76BlIMeta } from "/app/pages/resource/edit/[id].vue?macro=true";
import { default as indexN0Jsn3Da9fLC5RjN9s2t98owjEqS6ThROTyUx0RARmAMeta } from "/app/pages/service-type/index.vue?macro=true";
import { default as index_5HwpLrspoiI5mMsZ2v7BiAd_455ZbC0fV3ovhMZA0zOEMeta } from "/app/pages/transactions/index.vue?macro=true";
import { default as _91id_93ASYVm07y4tjEAQQuePTWrmM4pDBpu77xhNz5QVhE8KUMeta } from "/app/pages/assistant/edit/[id].vue?macro=true";
import { default as forgotPasswordpvtQRlI3TzFiRQ71Z0I6KqmfIXtTwp3lD_45MibUU2WLcMeta } from "/app/pages/auth/forgotPassword.vue?macro=true";
import { default as _91id_93FCfJd3XuGAqC5zYG1p2BgfWmEastzix2fYuJ_508Ts0Meta } from "/app/pages/customers/edit/[id].vue?macro=true";
import { default as index2ycxQ69FNk093c1SxVJPGFQBVmJILAMNr7iuaNVExpgMeta } from "/app/pages/db-connection/index.vue?macro=true";
import { default as _91id_93l8iCyK5lhC8RJ63ReY1EElHlDGwKijm3lZX0Q8dHWREMeta } from "/app/pages/insurance/edit/[id].vue?macro=true";
import { default as ModalDelete8poXDWIsuUSV2d1Rn1slNvZPAOnTjAy5b2oYjuAbJNQMeta } from "/app/pages/invoice/ModalDelete.vue?macro=true";
import { default as _91id_93bNt_45jKEwXoRGjHld9iE_ZjZGLnnAreL7jojhppPszEIMeta } from "/app/pages/procedure/edit/[id].vue?macro=true";
import { default as indexyHXctLo6PbuDVwy6zlGSdK4T3hzbyQxtxynebjMXIiQMeta } from "/app/pages/recovery-beds/index.vue?macro=true";
import { default as indexolMzPnLC6QttBBfeEinWUudTZInBA9uFop71BAH1Ek8Meta } from "/app/pages/report-config/index.vue?macro=true";
import { default as createpqBSZ3TOFA7mbCTgvvmKhCNJ4Imbz4KHyfIvC9oexUkMeta } from "/app/pages/service-type/create.vue?macro=true";
import { default as _91id_93BmaSZlmFIJO7U9M_45U99nQ2hyGARqDNHJBUZCb24pPxMMeta } from "/app/pages/surgeries/edit/[id].vue?macro=true";
import { default as indexGbUSA3OXPLSQBpwN_45Duetjuz2ziOoVYi1niGOvDawyMMeta } from "/app/pages/admin-services/index.vue?macro=true";
import { default as indexaeqO4HBhxCL_zvoVNYlXA8J5e7gLl8_45UTOehInIkx4gMeta } from "/app/pages/assign-modules/index.vue?macro=true";
import { default as change_45passwordTzyC_9WlKDb6qroMbxS_LC_45_Q_6j60EvRxaGrUFd5VYMeta } from "/app/pages/auth/change-password.vue?macro=true";
import { default as DashboardVIsshmvRPglIK6IRm28dCH_RsE6u6uYHBN2XYLn3kbQMeta } from "/app/pages/dashboards/Dashboard.vue?macro=true";
import { default as indexThM1nUFPXR61bhS9hoHj70dcVUgDbhlRJxU2eka_Z4kMeta } from "/app/pages/emergency-form/index.vue?macro=true";
import { default as indexCT6Hi5SAEEpX1NPXnwFzrw7vcRaY7ihteshUHt_w59YMeta } from "/app/pages/gediatric-form/index.vue?macro=true";
import { default as indexW5rk1jOrK7l1eUiKe4ALjAHVY9X885HPsXbH2Etq2U0Meta } from "/app/pages/mailjet-config/index.vue?macro=true";
import { default as index743GDb0VVGk_45lPK1mBy_45XrXU07qVKpAWsbfnDFDtsuwMeta } from "/app/pages/reconciliation/index.vue?macro=true";
import { default as createJZyQi_v27CX5CBFDIkscGibn6945lWT2aqiF3AjlbAgMeta } from "/app/pages/report-config/create.vue?macro=true";
import { default as indexxGohWMBPXdG6VtbCTrr27IEsksjVh_o3zBBqYPl7zkQMeta } from "/app/pages/admin-procedure/index.vue?macro=true";
import { default as createFijfEKs7QJ5mTCzTBfceLHw97NEEk6_tPfVOUAWuSJAMeta } from "/app/pages/admin-services/create.vue?macro=true";
import { default as _91id_93JIbSu_v6WetEycEnDFOYWdVS193ZCgkrOsL0_mNg7_YMeta } from "/app/pages/appointment/edit/[id].vue?macro=true";
import { default as indexxp8HfXwpc76AwX7j0elzDv2byye3nyo75DcD9k74LMYMeta } from "/app/pages/attention-rooms/index.vue?macro=true";
import { default as _91id_931DgIcSoqFIFMkCTVqPqWOrFvfQqMCLAebW_45T5xLkqHsMeta } from "/app/pages/business/profile/[id].vue?macro=true";
import { default as createg20h0uNvhXYUreX3SQbh5_45wK9TwCe1z2W6PbYos_huwMeta } from "/app/pages/mailjet-config/create.vue?macro=true";
import { default as indexUYpIZ__45_45jnshLBOdbg8P8TN6lWEMXpZ1J8AJdmLlqO4Meta } from "/app/pages/operating-rooms/index.vue?macro=true";
import { default as _91id_9358bU0qvFxzGAT1kh_45OR8E_4545vgWGQ8MyB29aMmbKsjMMeta } from "/app/pages/permissions/edit/[id].vue?macro=true";
import { default as createEj2ezS86KPly_VE_45ST13b8KBFwtdfFEzCaQBd3zkfWEMeta } from "/app/pages/admin-procedure/create.vue?macro=true";
import { default as indexiYlMcxxKbGAn7y8f4zYlXJBAin_45H_eIVQHqrd5TVC1wMeta } from "/app/pages/invoice-customer/index.vue?macro=true";
import { default as indexAre7rZULlhUcoFgB2B1qiBFmu5Quf8L7A_45h76iYh9cAMeta } from "/app/pages/laboratory-tests/index.vue?macro=true";
import { default as indexsBu8wJAf7lzDuqKpCAW8Y3pytPHw2r9XVNfLvq5m7VgMeta } from "/app/pages/mailjet-campaign/index.vue?macro=true";
import { default as indexT2WVBOYC_9Z7dPoLjOVM0bVqMpvCzdxeTFWAC7jdQGMMeta } from "/app/pages/mailjet-template/index.vue?macro=true";
import { default as index_32copyzoQr_Tsy1iB3AYKY6HOK2QMcvAQUf5zbQZfVMNA6xDMMeta } from "/app/pages/payment-btn/index copy.vue?macro=true";
import { default as _91id_93TpCaE6ITzCKNlERa1nObORP0cR5yBPIEsf7GA5jKTg0Meta } from "/app/pages/service-type/edit/[id].vue?macro=true";
import { default as _91id_93CiIB5pUfgPt5P1UlYPTzvujza67ticPsCaxrQPnyKHAMeta } from "/app/pages/surgeries/summary/[id].vue?macro=true";
import { default as indexmch0Ly5fk2N7gd3WJ_VCf_45_9hOBi13_45vHw_45yXrUy8CIMeta } from "/app/pages/surgery-planning/index.vue?macro=true";
import { default as importekdoD98H_xTGF9cDUdgAjoIY2d4DUK1jckq8gxwwWcYMeta } from "/app/pages/mailjet-campaign/import.vue?macro=true";
import { default as createzpKpQLLZ8c6a_458WCObwfovzaY1SQ6NatLbOmNqcpFj8Meta } from "/app/pages/mailjet-template/create.vue?macro=true";
import { default as _91id_93rthypCJjDZvBET75feeXw6MBaMziiG8hWKoHCh1QGtwMeta } from "/app/pages/report-config/edit/[id].vue?macro=true";
import { default as indexFhpUAKu_TxNBSiNDF1SWwjEFTkrlh0d1c_eFgxMxD6wMeta } from "/app/pages/accounting-closing/index.vue?macro=true";
import { default as _91id_93wvyf2Fvx0tBnVUdH1CkfgKEzfGUHF_qYJRwsu9nKyMMMeta } from "/app/pages/admin-services/edit/[id].vue?macro=true";
import { default as resetPasswordDialogR_45jwfyn5dNHwKpz_VbOlzBqM5y5m1c3g0rVXDJF9UhYMeta } from "/app/pages/auth/resetPasswordDialog.vue?macro=true";
import { default as Invoice_45EmissionZxBfn69XQyBq2eveMBB0D4kVn2lHrPMbs3VmCBlLRn4Meta } from "/app/pages/invoice/Invoice-Emission.vue?macro=true";
import { default as _91id_93gtgAO128nujrisZ_45qfMe0MKXJ2P3sMJpNTrsqtG6vkEMeta } from "/app/pages/mailjet-config/edit/[id].vue?macro=true";
import { default as indexCSjoqv4GClBQsEHsWme4OKbcEEWpzvVpHXGcsTZFXT0Meta } from "/app/pages/turner-specialties/index.vue?macro=true";
import { default as _91id_93RaWIIoaUcyPwIglEzhygjYDtOo77z52M0w0F_aWrA8QMeta } from "/app/pages/admin-procedure/edit/[id].vue?macro=true";
import { default as createMF_45F8vFCHrCGLbeSt4QZ97vakp1fDRZ89MAcW_45mc0NoMeta } from "/app/pages/turner-specialties/create.vue?macro=true";
import { default as _91id_93mQ8N8GkH8360isFq3LCFTMVEeWn4jiZgIHH_45pd1pRt4Meta } from "/app/pages/mailjet-template/edit/[id].vue?macro=true";
import { default as indexre0n6qOZc5oU7TD54Tl1reTirmjO4OL4XTdyzuBEwe0Meta } from "/app/pages/signature-management/index.vue?macro=true";
import { default as indexFSJmXgYqgTFpopmMi7_45ZfOuY1DPxaOJNd_45U6_wtCSckMeta } from "/app/pages/external-consultation/index.vue?macro=true";
import { default as indexaovEQgQVTjlMhiUkguxexVjKGfIJ137t9Hzy2sYYnDkMeta } from "/app/pages/laboratory-tests/[id]/index.vue?macro=true";
import { default as createi_uM_tG0WSuor_45mJxPjI7tP8TFcyLCjHb6T0h1TdVswMeta } from "/app/pages/external-consultation/create.vue?macro=true";
import { default as index2esO4FL9BYRVKv_B4UP3jdbEvxvYqMdVhYgRMAXfVwwcMeta } from "/app/pages/external-consultation/index2.vue?macro=true";
import { default as _91id_93yeMfAwOwLCh_HXeRUpgaJVvN8wKUWaJnw8qnICNFhZQMeta } from "/app/pages/turner-specialties/edit/[id].vue?macro=true";
import { default as _91id_93B5YMTAgwxQFBXLVxIibbjdK_45f_450p2V6FzAh4d3T2Fg8Meta } from "/app/pages/external-consultation/edit/[id].vue?macro=true";
import { default as index0_45C84dkunX9nloLZy8GBn6EbLDWqB9_45Qa4R_u8tdpswMeta } from "/app/pages/types-of-laboratory-tests/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "auth-error",
    path: "/auth/error",
    meta: errornGnnVf3YiwP60W_BCRsPvOMTJi0EztZBhT8ARDNnqAYMeta || {},
    component: () => import("/app/pages/auth/error.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "exam",
    path: "/exam",
    component: () => import("/app/pages/exam/index.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "role",
    path: "/role",
    component: () => import("/app/pages/role/index.vue")
  },
  {
    name: "user",
    path: "/user",
    component: () => import("/app/pages/user/index.vue")
  },
  {
    name: "block",
    path: "/block",
    component: () => import("/app/pages/block/index.vue")
  },
  {
    name: "files",
    path: "/files",
    component: () => import("/app/pages/files/index.vue")
  },
  {
    name: "nurse",
    path: "/nurse",
    component: () => import("/app/pages/nurse/index.vue")
  },
  {
    name: "place",
    path: "/place",
    component: () => import("/app/pages/place/index.vue")
  },
  {
    name: "rooms",
    path: "/rooms",
    component: () => import("/app/pages/rooms/index.vue")
  },
  {
    name: "taxes",
    path: "/taxes",
    component: () => import("/app/pages/taxes/index.vue")
  },
  {
    name: "user-create",
    path: "/user/create",
    component: () => import("/app/pages/user/create.vue")
  },
  {
    name: "user-index1",
    path: "/user/index1",
    component: () => import("/app/pages/user/index1.vue")
  },
  {
    name: "block-create",
    path: "/block/create",
    component: () => import("/app/pages/block/create.vue")
  },
  {
    name: "place-create",
    path: "/place/create",
    component: () => import("/app/pages/place/create.vue")
  },
  {
    name: "report",
    path: "/report",
    meta: indexM5K0l1sk3UKPNUQMqdQ0KewLr3G64wy_xltyH4w_45qCYMeta || {},
    component: () => import("/app/pages/report/index.vue")
  },
  {
    name: "user-create1",
    path: "/user/create1",
    component: () => import("/app/pages/user/create1.vue")
  },
  {
    name: "user-profile",
    path: "/user/profile",
    component: () => import("/app/pages/user/profile.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta || {},
    component: () => import("/app/pages/auth/register.vue")
  },
  {
    name: "invoice",
    path: "/invoice",
    component: () => import("/app/pages/invoice/index.vue")
  },
  {
    name: "modules",
    path: "/modules",
    component: () => import("/app/pages/modules/index.vue")
  },
  {
    name: "patient",
    path: "/patient",
    component: () => import("/app/pages/patient/index.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/app/pages/payment/index.vue")
  },
  {
    name: "service",
    path: "/service",
    component: () => import("/app/pages/service/index.vue")
  },
  {
    name: "vaccine",
    path: "/vaccine",
    component: () => import("/app/pages/vaccine/index.vue")
  },
  {
    name: "business",
    path: "/business",
    component: () => import("/app/pages/business/index.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    component: () => import("/app/pages/calendar/index.vue")
  },
  {
    name: "category",
    path: "/category",
    component: () => import("/app/pages/category/index.vue")
  },
  {
    name: "medicine",
    path: "/medicine",
    component: () => import("/app/pages/medicine/index.vue")
  },
  {
    name: "modules-create",
    path: "/modules/create",
    component: () => import("/app/pages/modules/create.vue")
  },
  {
    name: "patient-create",
    path: "/patient/create",
    component: () => import("/app/pages/patient/create.vue")
  },
  {
    name: "patient-index1",
    path: "/patient/index1",
    component: () => import("/app/pages/patient/index1.vue")
  },
  {
    name: "payment-create",
    path: "/payment/create",
    component: () => import("/app/pages/payment/create.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/app/pages/products/index.vue")
  },
  {
    name: "resource",
    path: "/resource",
    component: () => import("/app/pages/resource/index.vue")
  },
  {
    name: "user-edit-id",
    path: "/user/edit/:id()",
    component: () => import("/app/pages/user/edit/[id].vue")
  },
  {
    name: "vaccine-create",
    path: "/vaccine/create",
    component: () => import("/app/pages/vaccine/create.vue")
  },
  {
    name: "assistant",
    path: "/assistant",
    component: () => import("/app/pages/assistant/index.vue")
  },
  {
    name: "auth-lockScreen",
    path: "/auth/lockScreen",
    meta: lockScreenwHnOoC9OPAE0mUIumKItiYETIjpCVA0jJpTssyA3V2sMeta || {},
    component: () => import("/app/pages/auth/lockScreen.vue")
  },
  {
    name: "block-edit-id",
    path: "/block/edit/:id()",
    component: () => import("/app/pages/block/edit/[id].vue")
  },
  {
    name: "business-create",
    path: "/business/create",
    component: () => import("/app/pages/business/create.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/app/pages/customers/index.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/app/pages/insurance/index.vue")
  },
  {
    name: "place-edit-id",
    path: "/place/edit/:id()",
    component: () => import("/app/pages/place/edit/[id].vue")
  },
  {
    name: "procedure",
    path: "/procedure",
    component: () => import("/app/pages/procedure/index.vue")
  },
  {
    name: "resource-create",
    path: "/resource/create",
    component: () => import("/app/pages/resource/create.vue")
  },
  {
    name: "signature",
    path: "/signature",
    component: () => import("/app/pages/signature/index.vue")
  },
  {
    name: "surgeries",
    path: "/surgeries",
    component: () => import("/app/pages/surgeries/index.vue")
  },
  {
    name: "assistant-create",
    path: "/assistant/create",
    component: () => import("/app/pages/assistant/create.vue")
  },
  {
    name: "assistant-index1",
    path: "/assistant/index1",
    component: () => import("/app/pages/assistant/index1.vue")
  },
  {
    name: "auth-newPassword",
    path: "/auth/newPassword",
    meta: newPasswordSCSUfa4lH2XeJXN1a2W7vQO990GsvTqksaE2f2ZnKZQMeta || {},
    component: () => import("/app/pages/auth/newPassword.vue")
  },
  {
    name: "customers-create",
    path: "/customers/create",
    component: () => import("/app/pages/customers/create.vue")
  },
  {
    name: "insurance-create",
    path: "/insurance/create",
    component: () => import("/app/pages/insurance/create.vue")
  },
  {
    name: "procedure-create",
    path: "/procedure/create",
    component: () => import("/app/pages/procedure/create.vue")
  },
  {
    name: "surgeries-create",
    path: "/surgeries/create",
    component: () => import("/app/pages/surgeries/create.vue")
  },
  {
    name: "advertising",
    path: "/advertising",
    component: () => import("/app/pages/advertising/index.vue")
  },
  {
    name: "appointment",
    path: "/appointment",
    component: () => import("/app/pages/appointment/index.vue")
  },
  {
    name: "auth-accessDenied",
    path: "/auth/accessDenied",
    meta: accessDeniedyzjBPzCggfpfGkEi9AuxA94KFUZj80vEAf9kdsPTg94Meta || {},
    component: () => import("/app/pages/auth/accessDenied.vue")
  },
  {
    name: "auth-verification",
    path: "/auth/verification",
    meta: verificationbM4oBvUs_LE4PQnVgFXTHI2uwksUQUAY8fXuw96HK_EMeta || {},
    component: () => import("/app/pages/auth/verification.vue")
  },
  {
    name: "modules-edit-id",
    path: "/modules/edit/:id()",
    component: () => import("/app/pages/modules/edit/[id].vue")
  },
  {
    name: "new-patient",
    path: "/new-patient",
    component: () => import("/app/pages/new-patient/index.vue")
  },
  {
    name: "patient-edit-id",
    path: "/patient/edit/:id()",
    component: () => import("/app/pages/patient/edit/[id].vue")
  },
  {
    name: "payment-btn",
    path: "/payment-btn",
    meta: indext6RJr_45gIt8XR5r5pEpeQUyAPKNOA4LvS79ckdufflkMMeta || {},
    component: () => import("/app/pages/payment-btn/index.vue")
  },
  {
    name: "payment-edit-id",
    path: "/payment/edit/:id()",
    component: () => import("/app/pages/payment/edit/[id].vue")
  },
  {
    name: "permissions",
    path: "/permissions",
    component: () => import("/app/pages/permissions/index.vue")
  },
  {
    name: "service-edit-id",
    path: "/service/edit/:id()",
    component: () => import("/app/pages/service/edit/[id].vue")
  },
  {
    name: "vaccine-edit-id",
    path: "/vaccine/edit/:id()",
    component: () => import("/app/pages/vaccine/edit/[id].vue")
  },
  {
    name: "appointment-create",
    path: "/appointment/create",
    component: () => import("/app/pages/appointment/create.vue")
  },
  {
    name: "business-edit-id",
    path: "/business/edit/:id()",
    component: () => import("/app/pages/business/edit/[id].vue")
  },
  {
    name: "consultation",
    path: "/consultation",
    component: () => import("/app/pages/consultation/index.vue")
  },
  {
    name: "permissions-create",
    path: "/permissions/create",
    component: () => import("/app/pages/permissions/create.vue")
  },
  {
    name: "resource-edit-id",
    path: "/resource/edit/:id()",
    component: () => import("/app/pages/resource/edit/[id].vue")
  },
  {
    name: "service-type",
    path: "/service-type",
    component: () => import("/app/pages/service-type/index.vue")
  },
  {
    name: "transactions",
    path: "/transactions",
    component: () => import("/app/pages/transactions/index.vue")
  },
  {
    name: "assistant-edit-id",
    path: "/assistant/edit/:id()",
    component: () => import("/app/pages/assistant/edit/[id].vue")
  },
  {
    name: "auth-forgotPassword",
    path: "/auth/forgotPassword",
    meta: forgotPasswordpvtQRlI3TzFiRQ71Z0I6KqmfIXtTwp3lD_45MibUU2WLcMeta || {},
    component: () => import("/app/pages/auth/forgotPassword.vue")
  },
  {
    name: "customers-edit-id",
    path: "/customers/edit/:id()",
    component: () => import("/app/pages/customers/edit/[id].vue")
  },
  {
    name: "db-connection",
    path: "/db-connection",
    component: () => import("/app/pages/db-connection/index.vue")
  },
  {
    name: "insurance-edit-id",
    path: "/insurance/edit/:id()",
    component: () => import("/app/pages/insurance/edit/[id].vue")
  },
  {
    name: "invoice-ModalDelete",
    path: "/invoice/ModalDelete",
    component: () => import("/app/pages/invoice/ModalDelete.vue")
  },
  {
    name: "procedure-edit-id",
    path: "/procedure/edit/:id()",
    component: () => import("/app/pages/procedure/edit/[id].vue")
  },
  {
    name: "recovery-beds",
    path: "/recovery-beds",
    component: () => import("/app/pages/recovery-beds/index.vue")
  },
  {
    name: "report-config",
    path: "/report-config",
    component: () => import("/app/pages/report-config/index.vue")
  },
  {
    name: "service-type-create",
    path: "/service-type/create",
    component: () => import("/app/pages/service-type/create.vue")
  },
  {
    name: "surgeries-edit-id",
    path: "/surgeries/edit/:id()",
    component: () => import("/app/pages/surgeries/edit/[id].vue")
  },
  {
    name: "admin-services",
    path: "/admin-services",
    component: () => import("/app/pages/admin-services/index.vue")
  },
  {
    name: "assign-modules",
    path: "/assign-modules",
    component: () => import("/app/pages/assign-modules/index.vue")
  },
  {
    name: "auth-change-password",
    path: "/auth/change-password",
    meta: change_45passwordTzyC_9WlKDb6qroMbxS_LC_45_Q_6j60EvRxaGrUFd5VYMeta || {},
    component: () => import("/app/pages/auth/change-password.vue")
  },
  {
    name: "dashboards-Dashboard",
    path: "/dashboards/Dashboard",
    component: () => import("/app/pages/dashboards/Dashboard.vue")
  },
  {
    name: "emergency-form",
    path: "/emergency-form",
    component: () => import("/app/pages/emergency-form/index.vue")
  },
  {
    name: "gediatric-form",
    path: "/gediatric-form",
    component: () => import("/app/pages/gediatric-form/index.vue")
  },
  {
    name: "mailjet-config",
    path: "/mailjet-config",
    component: () => import("/app/pages/mailjet-config/index.vue")
  },
  {
    name: "reconciliation",
    path: "/reconciliation",
    component: () => import("/app/pages/reconciliation/index.vue")
  },
  {
    name: "report-config-create",
    path: "/report-config/create",
    component: () => import("/app/pages/report-config/create.vue")
  },
  {
    name: "admin-procedure",
    path: "/admin-procedure",
    component: () => import("/app/pages/admin-procedure/index.vue")
  },
  {
    name: "admin-services-create",
    path: "/admin-services/create",
    component: () => import("/app/pages/admin-services/create.vue")
  },
  {
    name: "appointment-edit-id",
    path: "/appointment/edit/:id()",
    component: () => import("/app/pages/appointment/edit/[id].vue")
  },
  {
    name: "attention-rooms",
    path: "/attention-rooms",
    component: () => import("/app/pages/attention-rooms/index.vue")
  },
  {
    name: "business-profile-id",
    path: "/business/profile/:id()",
    component: () => import("/app/pages/business/profile/[id].vue")
  },
  {
    name: "mailjet-config-create",
    path: "/mailjet-config/create",
    component: () => import("/app/pages/mailjet-config/create.vue")
  },
  {
    name: "operating-rooms",
    path: "/operating-rooms",
    component: () => import("/app/pages/operating-rooms/index.vue")
  },
  {
    name: "permissions-edit-id",
    path: "/permissions/edit/:id()",
    component: () => import("/app/pages/permissions/edit/[id].vue")
  },
  {
    name: "admin-procedure-create",
    path: "/admin-procedure/create",
    component: () => import("/app/pages/admin-procedure/create.vue")
  },
  {
    name: "invoice-customer",
    path: "/invoice-customer",
    component: () => import("/app/pages/invoice-customer/index.vue")
  },
  {
    name: "laboratory-tests",
    path: "/laboratory-tests",
    component: () => import("/app/pages/laboratory-tests/index.vue")
  },
  {
    name: "mailjet-campaign",
    path: "/mailjet-campaign",
    component: () => import("/app/pages/mailjet-campaign/index.vue")
  },
  {
    name: "mailjet-template",
    path: "/mailjet-template",
    component: () => import("/app/pages/mailjet-template/index.vue")
  },
  {
    name: "payment-btn-index copy",
    path: "/payment-btn/index%20copy",
    meta: index_32copyzoQr_Tsy1iB3AYKY6HOK2QMcvAQUf5zbQZfVMNA6xDMMeta || {},
    component: () => import("/app/pages/payment-btn/index copy.vue")
  },
  {
    name: "service-type-edit-id",
    path: "/service-type/edit/:id()",
    component: () => import("/app/pages/service-type/edit/[id].vue")
  },
  {
    name: "surgeries-summary-id",
    path: "/surgeries/summary/:id()",
    component: () => import("/app/pages/surgeries/summary/[id].vue")
  },
  {
    name: "surgery-planning",
    path: "/surgery-planning",
    component: () => import("/app/pages/surgery-planning/index.vue")
  },
  {
    name: "mailjet-campaign-import",
    path: "/mailjet-campaign/import",
    component: () => import("/app/pages/mailjet-campaign/import.vue")
  },
  {
    name: "mailjet-template-create",
    path: "/mailjet-template/create",
    component: () => import("/app/pages/mailjet-template/create.vue")
  },
  {
    name: "report-config-edit-id",
    path: "/report-config/edit/:id()",
    component: () => import("/app/pages/report-config/edit/[id].vue")
  },
  {
    name: "accounting-closing",
    path: "/accounting-closing",
    component: () => import("/app/pages/accounting-closing/index.vue")
  },
  {
    name: "admin-services-edit-id",
    path: "/admin-services/edit/:id()",
    component: () => import("/app/pages/admin-services/edit/[id].vue")
  },
  {
    name: "auth-resetPasswordDialog",
    path: "/auth/resetPasswordDialog",
    component: () => import("/app/pages/auth/resetPasswordDialog.vue")
  },
  {
    name: "invoice-Invoice-Emission",
    path: "/invoice/Invoice-Emission",
    component: () => import("/app/pages/invoice/Invoice-Emission.vue")
  },
  {
    name: "mailjet-config-edit-id",
    path: "/mailjet-config/edit/:id()",
    component: () => import("/app/pages/mailjet-config/edit/[id].vue")
  },
  {
    name: "turner-specialties",
    path: "/turner-specialties",
    component: () => import("/app/pages/turner-specialties/index.vue")
  },
  {
    name: "admin-procedure-edit-id",
    path: "/admin-procedure/edit/:id()",
    component: () => import("/app/pages/admin-procedure/edit/[id].vue")
  },
  {
    name: "turner-specialties-create",
    path: "/turner-specialties/create",
    component: () => import("/app/pages/turner-specialties/create.vue")
  },
  {
    name: "mailjet-template-edit-id",
    path: "/mailjet-template/edit/:id()",
    component: () => import("/app/pages/mailjet-template/edit/[id].vue")
  },
  {
    name: "signature-management",
    path: "/signature-management",
    component: () => import("/app/pages/signature-management/index.vue")
  },
  {
    name: "external-consultation",
    path: "/external-consultation",
    component: () => import("/app/pages/external-consultation/index.vue")
  },
  {
    name: "laboratory-tests-id",
    path: "/laboratory-tests/:id()",
    component: () => import("/app/pages/laboratory-tests/[id]/index.vue")
  },
  {
    name: "external-consultation-create",
    path: "/external-consultation/create",
    component: () => import("/app/pages/external-consultation/create.vue")
  },
  {
    name: "external-consultation-index2",
    path: "/external-consultation/index2",
    component: () => import("/app/pages/external-consultation/index2.vue")
  },
  {
    name: "turner-specialties-edit-id",
    path: "/turner-specialties/edit/:id()",
    component: () => import("/app/pages/turner-specialties/edit/[id].vue")
  },
  {
    name: "external-consultation-edit-id",
    path: "/external-consultation/edit/:id()",
    component: () => import("/app/pages/external-consultation/edit/[id].vue")
  },
  {
    name: "types-of-laboratory-tests",
    path: "/types-of-laboratory-tests",
    component: () => import("/app/pages/types-of-laboratory-tests/index.vue")
  }
]